import { Link } from '@tanstack/react-router';
import {
  LayoutDashboard,
  ListChecks,
  Upload,
  PiggyBank,
  Target,
  Tags,
  Sparkles,
  Bell,
  MessageSquare,
} from 'lucide-react';
import { cn } from '@/lib/utils';

const items: Array<{ to: string; label: string; icon: React.ComponentType<{ className?: string }> }> = [
  { to: '/', label: 'Dashboard', icon: LayoutDashboard },
  { to: '/transactions', label: 'Transactions', icon: ListChecks },
  { to: '/import', label: 'Import CAMT', icon: Upload },
  { to: '/budgets', label: 'Budgets', icon: PiggyBank },
  { to: '/goals', label: 'Objectifs', icon: Target },
  { to: '/categories', label: 'Catégories', icon: Tags },
  { to: '/insights', label: 'Bilans IA', icon: Sparkles },
  { to: '/alerts', label: 'Alertes', icon: Bell },
  { to: '/chat', label: 'Assistant', icon: MessageSquare },
];

export function Sidebar({ className }: { className?: string }) {
  return (
    <aside className={cn('border-r border-border bg-card', className)}>
      <div className="flex h-16 items-center gap-3 border-b border-border px-5">
        <div className="grid h-8 w-8 place-items-center rounded-md bg-primary text-primary-foreground font-bold">M</div>
        <div>
          <div className="font-semibold leading-tight">MyFinance</div>
          <div className="text-xs text-muted-foreground">v0.1 · CHF</div>
        </div>
      </div>
      <nav className="space-y-1 p-3">
        {items.map((it) => {
          const Icon = it.icon;
          return (
            <Link
              key={it.to}
              to={it.to}
              activeProps={{ className: 'bg-muted text-foreground' }}
              activeOptions={it.to === '/' ? { exact: true } : undefined}
              className="flex items-center gap-3 rounded-md px-3 py-2 text-sm text-muted-foreground transition-colors hover:bg-muted hover:text-foreground"
            >
              <Icon className="h-4 w-4" />
              {it.label}
            </Link>
          );
        })}
      </nav>
    </aside>
  );
}
